// import React, { useState } from "react";
import Header from "../../Components/Header/Header";
import Panel from "./Components/Panel";
// import AddCards from "./Components/AddCards/index";
import AddGleba from "./AddGleba";
import { useContext, useState } from "react";
import { ConfiguracaoGlebaContext } from "../../contexts/ConfiguracaoGlebaContext";
const Home = () => {
  const { setConfiguracaoGleba, programacaoAlterada } = useContext(
    ConfiguracaoGlebaContext
  );
  // const [formValue, setFormValue] = useState();
  const handleFormValue = (name) => {
    return (option) => {
      if (
        programacaoAlterada &&
        !window.confirm(
          "Você alterou a programação e não salvou. Se sair agora, vai perder as alterações. Deseja continuar?"
        )
      ) {
        return;
      }
      setConfiguracaoGleba((prev) => {
        const next = { ...prev, [name]: option.value };
        // Ao trocar produtor/fazenda, limpa as escolhas abaixo e a programacao antiga
        // (senao as abas do talhao anterior ficam aparecendo).
        if (name === "produtorId") {
          next.fazendaId = "";
          next.glebaId = "";
          next.culturas = [];
          next.defaultValues = { area: 0 };
        }
        if (name === "fazendaId") {
          next.glebaId = "";
          next.culturas = [];
          next.defaultValues = { area: 0 };
        }
        return next;
      });
    };
  };

  return (
    <div className="container-home">
      <Header />
      <Panel onFormValueChange={handleFormValue} />
      {/* <AddCards /> */}
      <AddGleba />
    </div>
  );
};

export default Home;
